import { render, staticRenderFns } from "./WapFields.vue?vue&type=template&id=2a9c4ed6&scoped=true&"
import script from "./WapFields.vue?vue&type=script&lang=js&"
export * from "./WapFields.vue?vue&type=script&lang=js&"
import style0 from "./WapFields.vue?vue&type=style&index=0&id=2a9c4ed6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c4ed6",
  null
  
)

export default component.exports